import { render, staticRenderFns } from "./AreaInformation.vue?vue&type=template&id=95fedc54&scoped=true"
import script from "./AreaInformation.vue?vue&type=script&lang=js"
export * from "./AreaInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95fedc54",
  null
  
)

export default component.exports